<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-data-provider-entity-page">
  <div class="consumer-data-provider-entity-page--layout">
    <app-consumer-sidebar #sidebar class="consumer-data-provider-entity-page--sidebar"></app-consumer-sidebar>
    <div class="consumer-data-provider-entity-page--content">
      <app-page-header></app-page-header>
      <div class="data-provider-entity-container">
        <!-- Pending Request Info Message -->
        <div *ngIf="organisationStatus === 'pending'" class="pending-request-info-wrapper">
          <div class="pending-request-info">
            <div class="pending-request-info--icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 16V12M12 8H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="pending-request-info--text">
              <ng-container *ngIf="isCreateRequest">
                <strong>Your request is still pending.</strong> Your request will be approved by the Platform Administrator shortly.
              </ng-container>
              <ng-container *ngIf="!isCreateRequest">
                <strong>Your request is still pending.</strong> Your request will be approved by the Organisation Administrator shortly.
              </ng-container>
            </div>
            <button
              *ngIf="!isCreateRequest"
              type="button"
              class="btn-withdraw-entity"
              [disabled]="withdrawing"
              (click)="onWithdrawClick()"
            >
              {{ withdrawing ? 'Withdrawing...' : 'Withdraw Request' }}
            </button>
          </div>
        </div>

        <!-- Granted Request Info Message -->
        <div *ngIf="organisationStatus === 'granted'" class="granted-request-info">
          <div class="granted-request-info--icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="granted-request-info--text">
            <strong>Your organisation has been approved.</strong> You can now access all organisation features and capabilities.
          </div>
        </div>

        <!-- Join Organisation Form (for organisation_join request type) -->
        <div *ngIf="isJoinRequest" class="form-card">
          <!-- Leaf Pattern Decoration -->
          <div class="form-card--leaf-pattern">
            <img src="/assets-leaf.png" alt="" class="form-card--leaf-image" />
          </div>
          
          <form [formGroup]="joinOrganisationForm" class="join-organisation-form">
            <!-- User Name (disabled) -->
            <div class="form-field">
              <label for="userName" class="form-label">
                User Name
              </label>
              <input
                type="text"
                id="userName"
                formControlName="userName"
                class="form-input input-disabled"
                placeholder="User name"
              />
            </div>

            <!-- Registered Email (disabled) -->
            <div class="form-field">
              <label for="registeredEmail" class="form-label">
                Registered Email
              </label>
              <input
                type="email"
                id="registeredEmail"
                formControlName="registeredEmail"
                class="form-input input-disabled"
                placeholder="Email address"
              />
            </div>

            <!-- Organisation Name -->
            <div class="form-field">
              <label for="entityName" class="form-label">
                Organisation Name
              </label>
              <input
                type="text"
                id="entityName"
                formControlName="entityName"
                class="form-input input-disabled"
                placeholder="Enter Organisation"
              />
            </div>

            <!-- Job Title -->
            <div class="form-field">
              <label for="jobTitle" class="form-label">
                Job Title
              </label>
              <input
                type="text"
                id="jobTitle"
                formControlName="jobTitle"
                class="form-input input-disabled"
                placeholder="Enter job title"
              />
            </div>

            <!-- Employee ID -->
            <div class="form-field">
              <label for="employeeId" class="form-label">
                Employee ID
              </label>
              <input
                type="text"
                id="employeeId"
                formControlName="employeeId"
                class="form-input input-disabled"
                placeholder="Enter employee ID"
              />
            </div>
          </form>
        </div>

        <!-- Organisation Form (for organisation_create request type) -->
        <app-data-provider-entity-form
          *ngIf="!isJoinRequest"
          [formData]="formData"
          [requestType]="requestType"
        ></app-data-provider-entity-form>
      </div>
    </div>
  </div>
</div>

<!-- Withdraw confirmation -->
<app-confirmation-dialog
  [(visible)]="showWithdrawConfirm"
  type="warning"
  title="Withdraw Request"
  message="Are you sure you want to withdraw your organisation join request? You can submit a new request later."
  confirmLabel="Withdraw"
  cancelLabel="Cancel"
  themeColor="orange"
  width="480px"
  [loading]="withdrawing"
  (onConfirm)="onWithdrawConfirm()"
  (onClose)="onWithdrawConfirmClose()"
></app-confirmation-dialog>
